import { Checkbox } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectRowHeader } from '@/redux/slices/dataTableSlice';
import { selectCheckedTableRows, selectCurrentTable, selectCurrentTableBulkActionsByStatusStage } from '@/redux/selectors/dataTableSelectors';

const TableHeaderCheckbox = () => {
  const dispatch = useAppDispatch();
  const { data: tableData } = useAppSelector(selectCurrentTable);
  const selectedRows = useAppSelector(selectCheckedTableRows);
  const selectActions = useAppSelector(selectCurrentTableBulkActionsByStatusStage);
  const selectableRows = tableData.filter((data) =>
    !data.status
      ? true
      : selectActions
        ? (data.status && selectActions[data.status]?.actions.length) || (data.stage && selectActions[data.status]?.stage[data.stage]?.length)
        : false
  );
  const isChecked = selectableRows.length > 0 && selectedRows.length === selectableRows.length;
  const isIndeterminate = selectedRows.length > 0 && selectedRows.length < selectableRows.length;

  const handleChange = (_: any, checked: boolean) => {
    // if indeterminate and you clicked the box, clear selected
    if ((isIndeterminate && checked) || isChecked) {
      dispatch(selectRowHeader([]));
      return;
    }

    if (selectableRows?.length) dispatch(selectRowHeader(selectableRows));
  };

  return (
    <Checkbox
      disabled={selectableRows.length === 0}
      checked={isChecked}
      indeterminate={isIndeterminate}
      onClick={(e) => e.stopPropagation()}
      onChange={handleChange}
    />
  );
};

export default TableHeaderCheckbox;
